export default class Experiment {
  identifier
  name
  archived
  sticky
  deploymentConfiguration
  flags
  labels
  stickinessProperty

  constructor(identifier, name, archived, sticky, deploymentConfiguration, flags, labels?, stickinessProperty?) {
    this.identifier = identifier;
    this.name = name;
    this.archived = archived;
    this.sticky = sticky;
    this.deploymentConfiguration = deploymentConfiguration;
    this.flags = flags;
    this.labels = labels;
    this.stickinessProperty = stickinessProperty;
  }
}
